export const formatCurrency = (v) => {
  if (v == null || isNaN(v)) return '—';
  const abs = Math.abs(v);
  if (abs >= 1_000_000_000) return `${v < 0 ? '-' : ''}$${(abs / 1_000_000_000).toFixed(2)}B`;
  if (abs >= 1_000_000) return `${v < 0 ? '-' : ''}$${(abs / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `${v < 0 ? '-' : ''}$${(abs / 1_000).toFixed(1)}K`;
  return `${v < 0 ? '-' : ''}$${abs.toFixed(0)}`;
};

export const formatCurrencyFull = (v) => {
  if (v == null || isNaN(v)) return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(v);
};

export const formatNumber = (v) => {
  if (v == null || isNaN(v)) return '—';
  const abs = Math.abs(v);
  if (abs >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(2)}B`;
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `${(v / 1_000).toFixed(1)}K`;
  return String(v);
};

export const formatInt = (v) => {
  if (v == null || isNaN(v)) return '—';
  return v.toLocaleString();
};

export const formatPercent = (v, digits = 1) => {
  if (v == null || isNaN(v)) return '—';
  return `${(v * 100).toFixed(digits)}%`;
};

export const formatPct = (v, digits = 1) => {
  // value already a percentage (0-100)
  if (v == null || isNaN(v)) return '—';
  return `${v.toFixed(digits)}%`;
};

export const formatCpm = (v) => {
  if (v == null || isNaN(v)) return '—';
  return `$${v.toFixed(2)} CPM`;
};

/** Null-safe Number#toFixed for table cells / KPIs (oil desks often null liftingCost, undiscCfM, etc.). */
export const formatFixed = (v, digits = 1) => {
  if (v == null || isNaN(v)) return '—';
  return Number(v).toFixed(digits);
};

/** `$x.xx` with optional unit suffix; em dash when null/NaN. */
export const formatUnitPrice = (v, unit = '', digits = 2) => {
  if (v == null || isNaN(v)) return '—';
  const core = `$${Number(v).toFixed(digits)}`;
  return unit ? `${core}${unit}` : core;
};

export const formatRange = (low, high, fn = formatCurrency) => {
  if (low == null || high == null) return '—';
  if (low === high) return fn(low);
  return `${fn(low)} – ${fn(high)}`;
};

export const formatDate = (s) => {
  if (!s) return '—';
  return new Date(s).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const formatMonth = (s) => {
  if (!s) return '—';
  const [y, m] = s.split('-');
  return new Date(Number(y), Number(m) - 1, 1).toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
};

export const truncate = (s, n = 40) => {
  if (!s) return '';
  return s.length > n ? s.slice(0, n - 1) + '…' : s;
};
